<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>

    <template slot="search-form">
      <el-form-item :label="$t('lang.语言分类')">
        <el-select clearable v-model="searchForm.lang">
          <el-option v-for="item in supportLangList" :key="item.value" :value="item.value" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" @click="handleReset">{{$t('lang.重置')}}</el-button>
      </el-form-item>
    </template>


    <template slot="table">

      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column prop="recipeCategoryNumber" :label="$t('lang.序号')"></el-table-column>
        <el-table-column prop="name" :label="$t('lang.分类名称')"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template slot-scope="{row}">
            <el-button size="mini" @click='$router.push({path: "detail",query: {code: row.code, name: row.name} });' plain  type="primary">
              {{ $t('lang.查看') }}</el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
export default {
  name: "OnlineCateList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.appOnlineCategory.list,
        batchDelete: this.$api.appOnlineCategory.batchDelete,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    supportLangList() {
      return this.$store.state.supportLangList;
    }
  },
  watch: {
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleSearch();

      },
      deep: true
    }

  },
  methods: {
    handleReset() {
      this.searchForm = {};
      this.pager.pageIndex = 1;
      this.handleSearch();
    },

    handleDelete(row) {
      let vm = this;
      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.batchDelete, [row.code]).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }
      let codes = this.selection.map(item => item.code);

      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        vm.$http.post(vm.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleSearch();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      let data = {...this.searchParams};
      data['brandOwnerCode'] = this.$store.state.userInfo['brandOwnerCode'];
      this.$http.post(this.api.list, this.$qs.stringify(data)).then((resp) => {

        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }
        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
